import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetReporteLogistica = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/reportes/logistica?empresa=${params.empresa}&status=${params?.status}&partes=${params.partes}&inicio=${params?.inicio}&fin=${params.fin}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getReporteLogisticaMutation: mutation.mutate,
  };
}